import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=64de834c&"
import script from "./TextQuestion.vue?vue&type=script&lang=js&"
export * from "./TextQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports